module.exports = __webpack_public_path__ + "static/media/fedora.642e1cd5.svg";